import React from 'react';
import ModalManager from '../modal-manager';
import { getContainer, open } from '../modal-container/ModalContainer';
import PictureViewer from '../picture/PictureViewer';
export default async function preview(props, modalProps) {
    const container = await getContainer();
    const customizedPrefixCls = container.context.getProPrefixCls('picture-viewer', props.prefixCls);
    open({
        key: ModalManager.getKey(),
        className: `${customizedPrefixCls}-modal`,
        border: false,
        header: null,
        footer: null,
        destroyOnClose: true,
        movable: false,
        closable: true,
        style: { width: 'auto' },
        fullScreen: true,
        maskClassName: `${customizedPrefixCls}-modal-mask`,
        children: (React.createElement(PictureViewer, Object.assign({ prefixCls: customizedPrefixCls }, props))),
        ...modalProps,
    });
}
